// import '~/packages/datakode/nuxt-datakode-utils/plugins/translation.ts'

export default {
    id: 'Id',
    commune: {
        t: 'Commune',
        name: 'Commune',
        insee: 'Code INSEE',
    },
    name: 'Nom',
    majic: {
        commands: {
            askCode: 'Recevoir le code',
            codeInput: 'Code de téléchargement',
            download: 'Télécharger',
            add: 'Ajouter une commande',
            fileDownloaded: {
                index: 'Ce fichier a déjà été téléchargé.',
                isExpired: 'Le délai de récupération de la commande est expiré, il n\'est plus possible de télécharger le fichier.',
                toaster: {
                    POST: {
                        success: {
                            title: 'Téléchargement de votre fichier',
                            text: 'Fichier téléchargé.',
                        },
                    },
                },
            },
            commune: {
                index: 'Commune',
                insee: 'Commune',
            },
            insee: 'Commune',
            custom_column: 'Actions',
            status: {
                pending: 'En attente de traitement',
                processing: 'En cours de traitement',
                error: 'Erreur',
                available: 'En attente de téléchargement',
                downloaded: 'Téléchargé',
                expired: 'Expiré',
                index: 'Statut',
            },
            matrice_type: {
                index: 'Type de livraison des matrices',
                dispersed: 'Matrices réparties à la commune',
                grouped: 'Matrices regroupées',
            },
            edit: 'Modifier la commande',
            cancel: 'Annuler',
            id: 'Id',
            name: 'Nom de la commande',
            nom: 'Nom',
            organization_id: 'Structure',
            structure_id: 'Structure',
            organization: {
                index: 'Structure',
                t: 'Structure',
                name: 'Structure',
            },
            codeRequest: {
                toaster: {
                    POST: {
                        success: {
                            title: 'Demande de code',
                            text: 'Vous allez recevoir votre code par mail',
                        },
                    },
                },
            },
            toaster: {
                POST: { success: { title: 'Commande', text: 'La commande a été créée' } },
                DELETE: {
                    success: {
                        text: 'La commande a été supprimée',
                        title: 'Commande',
                    },
                },
                PUT: {
                    success: {
                        text: 'La commande {id} a été modifié',
                        title: 'Commande',
                    },
                },
            },
            delete: {
                text: 'Voulez-vous confirmez la supression ?',
                title: 'Suppression de la commande',
                index: 'Confirmer',
            },
            year: 'Millésime',
            annee: 'Millésime',
            view: 'Visualisation',
            isHighlighted: 'À ajouter (survol)',
            isToBeDeleted: 'À retirer (survol)',
            isSelected: 'Déjà ajoutée',
            communes: {
                list: 'Liste des communes',
            },
        },
        Commands: {
            communes: {
                list: 'Liste des communes',
            },
        },
    },
    commandes: {
        index: 'Commandes',
        view: 'Visualisation d\'une commande',
    },
}
